<template>
    <v-combobox
      :model-value="uiValue"
      :items="apartments"
      item-title="name"
      item-value="value"
      return-object
      :custom-value="true"
      variant="underlined"
      density="compact"
      hide-details
      @update:modelValue="onUIChange"
    />
  </template>
  
  <script>
  import { APARTMENTS } from "@/IPA/Apartments";
  
  export default {
    name: "ApartamentSelect",
    props: {
      // may be number | string | null (BE sometimes sends "1" instead of 1)
      modelValue: {
        type: [Number, String, null],
        default: 0,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        apartments: APARTMENTS,
      };
    },
    computed: {
      // Normalize BE -> UI
      uiValue() {
       const v = this.modelValue ?? 0;
        if (v == null || v === "") return "";
  
        // If it's a numeric string like "1", treat as number
        const asNumber = this.toNumberIfNumeric(v);
        if (typeof asNumber === "number") {
          return (
            this.apartments.find(a => a.value === asNumber) ||
            { name: String(asNumber), value: asNumber }
          );
        }
  
        // Free text string stays string
        return String(v);
      },
    },
    methods: {
      // helper: "1" -> 1, "  2 " -> 2, otherwise returns original value
      toNumberIfNumeric(v) {
        if (typeof v === "number") return v;
        if (typeof v === "string") {
          const trimmed = v.trim();
          if (/^-?\d+$/.test(trimmed)) return Number(trimmed);
        }
        return v;
      },
  
      // UI -> BE
      toBackend(v) {
        if (v == null || v === "") return null;
  
        // enum object => keep the numeric value
        if (typeof v === "object") return v.value ?? null;
  
        // string typed: try to map by name first (case-insensitive)
        const s = String(v).trim();
        const byName = this.apartments.find(
          a => a.name.toLowerCase() === s.toLowerCase()
        );
        if (byName) return byName.value;
  
        // if it's a numeric string and matches an enum value, return number
        if (/^-?\d+$/.test(s)) {
          const n = Number(s);
          const byValue = this.apartments.find(a => a.value === n);
          if (byValue) return n;        // store as number for BE
        }
  
        // otherwise keep free text
        return s;
      },
  
      onUIChange(v) {
        this.$emit("update:modelValue", this.toBackend(v));
      },
    },
  };
  </script>
  